<template>
    <div>
        <my-header @userInfo="getuserInfo"></my-header>
        <div class="member">
            <div class="content">
                <div class="member-header">
                    <img src="@images/member/member_logo.png" alt="" />
                    <h1>用途范围及会员服务对比</h1>
                    <div class="bothclear"></div>
                </div>
                <div class="hysection">
                    <my-table  :data="$store.state.memberlist">
                        <el-table-column prop="dbx" label="对比项">

                        </el-table-column>
                        <el-table-column prop="ptfw" label="普通服务">
                            <template slot-scope="scope">
                                <img :src="scope.row.ptfw" alt="">
                            </template>
                        </el-table-column>
                        <el-table-column prop="hyfw" label="会员服务">
                            <template slot-scope="scope">
                                <img :src="scope.row.hyfw" alt="">
                            </template>
                        </el-table-column>
                        <el-table-column prop="hyyt" label="会员用途">
                            <template slot-scope="scope">
                                <div v-html="scope.row.hyyt"></div>
                            </template>
                        </el-table-column>
                    </my-table>
                </div>
                <a class="ktmember" href="/sign">
                    开通会员
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    head: {
        title: '会员服务·电子保函查验平台'
    },
    data: () => ({
        userInfo:''
    }),
    methods: {
        getuserInfo(data){
            this.userInfo=data;
        },
    },
    created() {},
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    .header{
        background-image: url(~@images/guarantee/banner2.jpg);  
        background-repeat: no-repeat;
        background-position:0 -56px;
        background-size:cover;         
    }
    .bothclear{
        clear:both;
    }
    .member{
        font-family: Microsoft YaHei;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        min-height:592px;
        background: #f9fafb;
        padding-bottom: 85px;
        .content{
            .member-header{
                width:100%;
                padding:40px 0 35px 0;
                line-height:38px;
                img{
                    display:block;
                    float: left;
                }
                h1{
                    float: left;
                    font-size: 30px;
                    margin-left:21px;
                }
            }

            .hysection{
                width: 100%;
                background-color: #ffffff;
                box-shadow: 0px 3px 12px 0px  rgba(152, 157, 171, 0.08);
                padding:32px 25px 35px 25px;
                margin-bottom:46px;
                border-radius: 4px;
            }
            .ktmember{
                display: block;
                cursor: pointer;
                width: 164px;
                height: 58px;
                line-height: 58px;
                text-align: center;
                margin:0 auto;
                background-color: #ffb73b;
                color:#ffffff;
                font-size: 22px;
                border-radius: 4px;
                &:hover{
                    opacity: 0.8;
                }
            }
        }
    }
   
</style>
